import FalconComponentCard from "components/common/FalconComponentCard";
import { Button, Col, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import AddFieldSettingsForm from "./components/AddFieldSettingsForm";
import { EditSettings, ViewSettings } from "./config/FieldSettingsApi";
import { toast } from "react-toastify";
import { useEffect } from "react";

const FieldSettings = () => {
  const dispatch = useDispatch();
  const {
    visitReasons,
    processPriority,
    serviceTypeList,
    preauthorizationType,
    preauthorizationSubType,
    investgationList,
  } = useSelector((state) => state.preauthorization);
  const { settingData } = useSelector((state) => state.settings);
  const { allPermissionType } = useSelector((state) => state.role);
  const fieldSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) => item?.rolemngmttyp_name === "Field Settings"
  );
  const {
    control,
    watch,
    setValue,
    reset,
    handleSubmit,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: {},
  });
  const handleReset = () => {
    reset();
  };
  const handleAddFieldSettings = async (data) => {
    const payload = {
      server_url: data?.server_url || "http://212.227.240.195",
      nphies_url: data?.nphies_url || "http://176.105.150.83/$process-message",
      group_vat: data?.group_vat ? 1 : 0 || 1,
      boarding_type: data?.boarding_type || "test",
      field_setting: {
        supinfo_attch: data?.attachemnt ? 1 : 0 || 0,
        sve_preauth: data?.save_preauth ? 1 : 0 || 0,
        icd_cdes: "",
        process_prior: data?.priority_type?.prcspri_code || "",
        sup_info_vreas: data?.visit_reason?.visitreas_code || "",
        claim_type: data?.preauthorization_type?.claim_types_id || "",
        claimsub_types_name:
          data?.preauthorization_sub_type?.claimsub_types_id || "",
        prd_type: data?.service_type?.servtype_code || "",
        sup_info_invres: data?.investgation_result?.investreslttype_code || "",
        sup_info_trtpln: data?.treatment_plan || "",
        sup_info_pathistry: data?.patient_history || "",
        sup_info_phyexmn: data?.patient_examination || "",
        sup_info_histrypreill: data?.history_present_illness || "",
      },
    };

    const response = await dispatch(EditSettings(payload)).unwrap();
    if (response?.success) {
      toast.success(response?.message_en);
      const res = await dispatch(ViewSettings()).unwrap();
    } else {
      toast.error(response?.message_en);
    }
  };
  useEffect(() => {
    const data = settingData?.[0];
    setValue("server_url", data?.server_url || "");
    setValue("nphies_url", data?.nphies_url || "");
    setValue("boarding_type", data?.boarding_type || "");
    setValue("group_vat", data?.group_vat == 1 ? true : false || false);
    setValue(
      "attachemnt",
      data?.fieldsetting_txt?.supinfo_attch == 1 ? true : false || false
    );
    setValue(
      "save_preauth",
      data?.fieldsetting_txt?.sve_preauth == 1 ? true : false || false
    );
    setValue(
      "visit_reason",
      visitReasons?.find(
        (item) =>
          item?.visitreas_code === data?.fieldsetting_txt?.sup_info_vreas
      )
    );
    setValue(
      "preauthorization_type",
      preauthorizationType?.find(
        (item) => item?.claim_types_id === data?.fieldsetting_txt?.claim_type
      )
    );
    setValue(
      "preauthorization_sub_type",
      preauthorizationSubType?.find(
        (item) =>
          item?.claimsub_types_id ===
          data?.fieldsetting_txt?.claimsub_types_name
      )
    );
    setValue(
      "priority_type",
      processPriority?.find(
        (item) => item?.prcspri_code === data?.fieldsetting_txt?.process_prior
      )
    );
    setValue(
      "investgation_result",
      investgationList?.find(
        (item) =>
          item?.investreslttype_code === data?.fieldsetting_txt?.sup_info_invres
      )
    );
    setValue(
      "service_type",
      serviceTypeList?.find(
        (item) => item?.servtype_code === data?.fieldsetting_txt?.prd_type
      )
    );
    setValue("treatment_plan", data?.fieldsetting_txt?.sup_info_trtpln);
    setValue(
      "patient_history",
      data?.fieldsetting_txt?.sup_info_pathistry || ""
    );
    setValue("patient_examination", data?.fieldsetting_txt?.sup_info_phyexmn);
    setValue(
      "history_present_illness",
      data?.fieldsetting_txt?.sup_info_histrypreill
    );
  }, [setValue]);

  return (
    <>
      {Number(fieldSetting?.view) === 1 ? (
        <Form
          noValidate
          onSubmit={handleSubmit(handleAddFieldSettings)}
          className="p-0"
        >
          <FalconComponentCard
            className="shadow-md"
            style={{ position: "relative" }}
          >
            <FalconComponentCard.Header
              className="d-flex  fixed-header justify-content-between align-items-center"
              sx={{
                position: "sticky !important",
                top: 68,
                zIndex: 1020,
                backgroundColor: "white",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              <Col xs="auto m-0">
                <h5 className="text-primary mb-0 fs-10">Field Settings</h5>
              </Col>
              <Col xs="auto" className="d-flex gap-2">
                <Button
                  size="sm"
                  variant="outline-danger"
                  onClick={handleReset}
                >
                  Reset
                </Button>

                {(Number(fieldSetting?.edit) === 1) && (
                  <Button type="submit" size="sm" variant="success">
                    Save Changes
                  </Button>
                )}
              </Col>
            </FalconComponentCard.Header>
            <FalconComponentCard.Body>
              <AddFieldSettingsForm
                watch={watch}
                setValue={setValue}
                errors={errors}
                control={control}
                isSubmitted={isSubmitted}
              />
            </FalconComponentCard.Body>
          </FalconComponentCard>
        </Form>
      ) : (
        <div className="py-6 text-center border rounded-3mb-3">
          <h5 className="text-danger">Permission Denied</h5>
          <p className="text-muted fs-11">
            You do not have permission to view Field Settings.
          </p>
        </div>
      )}
    </>
  );
};

export default FieldSettings;

